<template>
    <div class="event-model-thumbnail" :title="label">
        <img v-if="image" :src="image" :alt="label" width="80" height="80" />
        <span v-else class="text-muted small text-center" role="status">{{ failed ? 'Sin vista previa' : 'Cargando…' }}</span>
    </div>
</template>

<script>
import default_model_url from '@/utils/jersey_model'
import { load_model_thumbnail } from '@/utils/model-thumbnail'

export default {
    props: {
        modelUrl: { type: String, default: null },
        label: { type: String, default: 'Modelo del evento' },
    },
    data(){
        return { image: null, failed: false, requestId: 0 };
    },
    watch: {
        modelUrl: {
            immediate: true,
            async handler(url){
                const requestId = ++this.requestId;
                this.image = null;
                this.failed = false;
                try{
                    const image = await load_model_thumbnail(url || default_model_url);
                    if(requestId === this.requestId) this.image = image;
                }catch(error){
                    if(requestId === this.requestId) this.failed = true;
                }
            },
        },
    },
    beforeUnmount(){ this.requestId++; },
}
</script>

<style scoped>
.event-model-thumbnail{
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e9edf0;
    border-radius: 8px;
    overflow: hidden;
}
.event-model-thumbnail img{ object-fit: contain; }
</style>
